import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import Menu from './MenuPage';

const PacienteCrud = (props) => {
    const [pacientes, setPacientes] = useState([]);
    const [paciente, setPaciente] = useState({
        id: 0, nome: '', idRaca: 0, dtNascimento: '', idTutor: 0, cor: '', sexo: '', rg: '', idEspecie: 0
    });
    const [tutores, setTutores] = useState([]);
    const [racas, setRacas] = useState([]);
    const [racasFiltradas, setRacasFiltradas] = useState([]);
    const [especies, setEspecies] = useState([]);

    useEffect(() => {
        carregarPacientes();
        carregarSelects();
    }, []);

    useEffect(() => {
        // Filtra as raças quando a espécie for alterada

        
        if (paciente.idEspecie) {
           console.log(paciente.idEspecie)
            const especieSelecionada = Number(paciente.idEspecie);

            // Filtrando as raças com base na espécie selecionada
            const racasFiltradas = racas.filter(raca => {
                
                return raca.idEspecie === especieSelecionada;
            });
            setRacasFiltradas(racasFiltradas);
        } else {
            setRacasFiltradas([]);
        }
       
    }, [paciente.idEspecie, racas]);

    const carregarPacientes = async () => {

        const token = localStorage.getItem("token");

       try {
    const response = await axios.get(`${API_BASE_URL}/paciente/getAll`, {
        headers: { "Authorization": `Bearer ${token}` }
    });

    setPacientes(response.data);

} catch (error) {
    console.error("ERRO 401 DETALHADO:", error.response);
    alert("Erro ao carregar pacientes: " + error.response.status);
}

    };

    const carregarSelects = async () => {
        //const idUsuario = localStorage.getItem("idUsuario");
        const token = localStorage.getItem("token");

        const config = {
         headers: { Authorization: `Bearer ${token}` }
        };

        const [tutoresResponse, racasResponse, especiesResponse] = await Promise.all([
            axios.get(`${API_BASE_URL}/tutor/getAll`, config),
            axios.get(`${API_BASE_URL}/raca`, config),
            axios.get(`${API_BASE_URL}/especie`, config)
        ]);

        setTutores(tutoresResponse.data);

        setRacas(racasResponse.data);
        setEspecies(especiesResponse.data);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPaciente((prevPaciente) => ({ ...prevPaciente, [name]: value }));
        
        if (paciente.idEspecie) {
            const especieSelecionada = Number(paciente.idEspecie);
    
            const racasFiltradas = racas.filter(raca => raca.idEspecie === especieSelecionada);
            setRacasFiltradas(racasFiltradas);
        }
 
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("token");

        if (paciente.id === 0) {
            const response = await axios.post(`${API_BASE_URL}/paciente`, paciente, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
                        
            if(props.onSave!=null)
               props.onSave(response.data);  // devolve para a modal
        } else {
            await axios.put(`${API_BASE_URL}/paciente`, paciente, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
        }
        carregarPacientes();
        setPaciente({ id: 0, nome: '', idRaca: 0, dtNascimento: '', idTutor: 0, cor: '', sexo: '', rg: '', idEspecie: 0 });
    };

    const handleEdit = (paciente) => {
        setPaciente(paciente);
    };

    const handleDelete = async (id) => {
         const token = localStorage.getItem("token");

        await axios.delete(`${API_BASE_URL}/paciente/${id}`, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
        carregarPacientes();
    };

    return (
        <div >
             {(props.onSave==null &&  <Menu />)}
            <div className="container">
            <h2 className="mb-4">Cadastro de Paciente</h2>
            <form onSubmit={handleSubmit} className="mb-4">
                <div className="mb-3">
                    <label className="form-label">Nome</label>
                    <input
                        type="text"
                        className="form-control"
                        name="nome"
                        value={paciente.nome}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Data de Nascimento</label>
                    <input
                        type="date"
                        className="form-control"
                        name="dtNascimento"
                        value={paciente.dtNascimento}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Cor</label>
                    <input
                        type="text"
                        className="form-control"
                        name="cor"
                        value={paciente.cor}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Sexo</label>
                    <select
                        
                        className="form-control"
                        name="sexo"
                        value={paciente.sexo}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Selecione o Sexo</option>
                        <option value="M">Macho</option>
                        <option value="F">Fêmea</option>
                        </select>
                </div>
                <div className="mb-3">
                    <label className="form-label">RG</label>
                    <input
                        type="text"
                        className="form-control"
                        name="rg"
                        value={paciente.rg}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Espécie</label>
                    <select
                        className="form-select"
                        name="idEspecie"
                        value={paciente.idEspecie}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Selecione a Espécie</option>
                        {especies.map((especie) => (
                            <option key={especie.id} value={especie.id}>{especie.descricao}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label className="form-label">Raça</label>
                    <select
                        className="form-select"
                        name="idRaca"
                        value={paciente.idRaca}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Selecione a Raça</option>
                        {racasFiltradas.map((raca) => (
                            <option key={raca.id} value={raca.id}>{raca.descricao}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label className="form-label">Tutor</label>
                    <select
                        className="form-select"
                        name="idTutor"
                        value={paciente.idTutor}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Selecione o Tutor</option>
                        {tutores.map((tutor) => (
                            <option key={tutor.id} value={tutor.id}>{tutor.nome}</option>
                        ))}
                    </select>
                </div>
              
                <button type="submit" className="btn btn-success w-100">Salvar</button>
            </form>
            {(props.onSave==null && 
            <div>
            <h3>Lista de Pacientes</h3>
            <ul className="list-group">
                {pacientes.map((pac) => (
                    <li key={pac.id} className="list-group-item d-flex justify-content-between align-items-center">
                        {pac.nome}
                        <div>
                            <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(pac)}>Editar</button>
                            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(pac.id)}>Excluir</button>
                        </div>
                    </li>
                ))}
            </ul>
            </div>)}
        </div>
        </div>
    );
};

export default PacienteCrud;
